import axios from 'axios';

import { API_URL } from '../config/apiConfig';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Add request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Handle authentication errors
    if (error.response?.status === 401) {
      console.error('Authentication error:', error.response?.data?.error || 'Please authenticate');
    }
    
    return Promise.reject(
      new Error(error.response?.data?.error || error.message || 'An error occurred')
    );
  }
);

export const getAllSettings = async () => {
  try {
    return await api.get('/api/settings');
  } catch (error) {
    console.error('Error in getAllSettings:', error);
    throw error;
  }
};

export const getSetting = async (key) => {
  try {
    return await api.get(`/api/settings/${key}`);
  } catch (error) {
    console.error(`Error in getSetting for key ${key}:`, error);
    throw error;
  }
};

export const updateSetting = async (key, value, description = '') => {
  try {
    return await api.put(`/api/settings/${key}`, { value, description });
  } catch (error) {
    console.error(`Error in updateSetting for key ${key}:`, error);
    throw error;
  }
};

// 2FA specific functions

export const getTwoFactorStatus = async () => {
  try {
    // Add a timestamp to prevent caching
    const timestamp = new Date().getTime();
    return await api.get(`/api/settings/2fa/status?_=${timestamp}`);
  } catch (error) {
    console.error('Error in getTwoFactorStatus:', error);
    throw error;
  }
};

export const updateTwoFactorStatus = async (enabled) => {
  try {
    return await api.put('/api/settings/2fa/status', { enabled });
  } catch (error) {
    console.error('Error in updateTwoFactorStatus:', error);
    throw error;
  }
};
